import { surfaces } from '@ui/kit';
import { combineTokens } from '@utils/css';

const tokens = combineTokens("--universal-lightbox-card", {
  badgeSurface: surfaces.accent.default
});
const wrapper = "_araw1ru77bc";
const contextMenu = "_arac1nkbd2r";
const button = "_arabyjnw7e";
const badgeWrapperCls = "_arabkx6uex";
const imageCls = "_arai1ru7qqa";
const badgeCls = "_arabvz8rm4";
const headingCls = "_arah9eijz2";
const descriptionCls = "_arad1k2wyif";
const checkmark = "_arac1f4doo";

export { badgeCls, badgeWrapperCls, button, checkmark, contextMenu, descriptionCls, headingCls, imageCls, tokens, wrapper };
import "./lightbox.card.style.linaria.module.css";
//# sourceMappingURL=lightbox.card.style.js.map
